module.exports = __webpack_public_path__ + "a4e13e97cc473c86a1d67faa0acb8baa.png";